import * as React from 'react'
import {Box, Typography} from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import {kpiCardSx, kpiValueSx, kpiLabelSx} from '../../../../styles/patterns'
import {SIZE, WEIGHT} from '../../../../styles/foundation/typography'
import {SUCCESS, PURPLE, WARNING, INFO, ERROR} from '../../../../styles/foundation/colors'
import {GAP} from '../../../../styles/foundation/spacing'
import {int} from '../format'

// These five tiles deliberately ignore the search box and the level filter —
// they answer "where does this merchant stand", which must not move when
// someone types. The TAB counts are the ones that follow the filters. See
// requestCounts vs filterRequests in requests/logic.js.
const TILES = [
  {id: 'approved', label: 'Approved', color: SUCCESS, Icon: CheckCircleOutlineIcon},
  {id: 'prelim', label: 'Still preliminary, under 2 cycles', color: PURPLE, Icon: AccessTimeIcon},
  {id: 'review', label: 'Under review with Prozo', color: WARNING, Icon: HourglassEmptyIcon},
  {id: 'asked', label: 'Waiting on data from you', color: INFO, Icon: HelpOutlineIcon},
  {id: 'rejected', label: 'Rejected', color: ERROR, Icon: CancelOutlinedIcon},
]

/**
 * Weight Freeze (v2) — Requests: the five stat tiles.
 *
 * The colours here are the SAME `toneColor`-backed palette the chips
 * elsewhere in this section use (STATUS_TONE in data/reference.js), so
 * these tiles double as the status colour legend — they must never drift
 * from the chip colours the merchant sees on the same screen.
 *
 * `kpiCardSx` carries `height: '100%'` (styles/patterns) — overridden to
 * 'auto' here, or the shortest tile stretches to match its tallest sibling.
 */
export default function RqStats({counts}) {
  return (
    <Box sx={{display: 'grid', gridTemplateColumns: {xs: '1fr 1fr', md: 'repeat(5, 1fr)'}, gap: GAP.md, alignItems: 'start'}}>
      {TILES.map((t) => (
        <Box key={t.id} sx={{...kpiCardSx(t.color), p: 1.25, height: 'auto'}}>
          <Box sx={{color: t.color, mb: 0.5, '& .MuiSvgIcon-root': {fontSize: 18}}}>
            <t.Icon />
          </Box>
          {/* Value/label/padding overridden to disputes-v2's own KpiStrip tier
              (sdd/type-parity-spec.md) — kpiValueSx/kpiLabelSx are shared with
              other modules and stay larger there. */}
          <Typography sx={{...kpiValueSx(t.color), fontSize: '18px', lineHeight: 1.25}}>{int(counts[t.id])}</Typography>
          <Typography sx={{...kpiLabelSx, fontSize: SIZE['2xs'], fontWeight: WEIGHT.medium}}>{t.label}</Typography>
        </Box>
      ))}
    </Box>
  )
}
